export default [{
  path: 'fuelManage',
  name: 'fuelManage',
  component: function component() {
    return import('@/views/fuelManage');
  }
}, {
  path: 'fuelOutManageList',
  name: 'fuelOutManageList',
  component: function component() {
    return import('@/views/fuelManage/fuelOutManage/index');
  }
}, {
  path: 'fuelOutManageDetail',
  name: 'fuelOutManageDetail',
  component: function component() {
    return import('@/views/fuelManage/fuelOutManage/detail');
  }
}, {
  path: 'fuelSignOffManageList',
  name: 'fuelSignOffManageList',
  component: function component() {
    return import('@/views/fuelManage/fuelSignOffManage/index');
  }
}, {
  path: 'fuelSignOffManageAdd',
  name: 'fuelSignOffManageAdd',
  component: function component() {
    return import('@/views/fuelManage/fuelSignOffManage/add');
  }
}, {
  path: 'fuelSignOffManageDetail',
  name: 'fuelSignOffManageDetail',
  component: function component() {
    return import('@/views/fuelManage/fuelSignOffManage/detail');
  }
}, {
  path: 'fuelSignOffManageUpdate',
  name: 'fuelSignOffManageUpdate',
  component: function component() {
    return import('@/views/fuelManage/fuelSignOffManage/update');
  }
}, {
  path: 'fuelInManageList',
  name: 'fuelInManageList',
  component: function component() {
    return import('@/views/fuelManage/fuelInManage/index');
  }
}, {
  path: 'fuelInManageAdd',
  name: 'fuelInManageAdd',
  component: function component() {
    return import('@/views/fuelManage/fuelInManage/add');
  }
}, {
  path: 'fuelInManageDetail',
  name: 'fuelInManageDetail',
  component: function component() {
    return import('@/views/fuelManage/fuelInManage/detail');
  }
}, {
  path: 'oilOmeterManagement',
  name: 'oilOmeterManagement',
  component: function component() {
    return import('@/views/fuelManage/oilOmeterManagement/index');
  }
}, {
  path: 'oilOmeterManagementDetail',
  name: 'oilOmeterManagementDetail',
  component: function component() {
    return import('@/views/fuelManage/oilOmeterManagement/detail');
  }
}, {
  path: 'fuelInImport',
  name: 'fuelInImport',
  component: function component() {
    return import('@/views/fuelManage/fuelInManage/import');
  }
}, {
  path: 'fuelOutImport',
  name: 'fuelOutImport',
  component: function component() {
    return import('@/views/fuelManage/fuelOutManage/import');
  }
}, {
  path: 'fuelStockAdd',
  name: 'fuelStockAdd',
  component: function component() {
    return import('@/views/fuelManage/fuelStockManage/add');
  }
}, {
  path: 'fuelStockList',
  name: 'fuelStockList',
  component: function component() {
    return import('@/views/fuelManage/fuelStockManage/index');
  }
}, {
  path: 'fuelStockLastList',
  name: 'fuelStockLastList',
  component: function component() {
    return import('@/views/fuelManage/fuelStockManage/lastList');
  }
}, {
  path: 'fuelVerifyManage',
  name: 'fuelVerifyManage',
  component: function component() {
    return import('@/views/fuelManage/fuelVerifyManage');
  }
}, {
  path: 'fuelVerifyAdd',
  name: 'fuelVerifyAdd',
  component: function component() {
    return import('@/views/fuelManage/fuelVerifyManage/add');
  }
}, {
  path: 'fuelVerifyBranchAdd',
  name: 'fuelVerifyBranchAdd',
  component: function component() {
    return import('@/views/fuelManage/fuelVerifyManage/branchAdd');
  }
}, {
  path: 'fuelVerifyDetail',
  name: 'fuelVerifyDetail',
  component: function component() {
    return import('@/views/fuelManage/fuelVerifyManage/detail');
  }
}, {
  path: 'fuelVerifySuccess',
  name: 'fuelVerifySuccess',
  component: function component() {
    return import('@/views/fuelManage/fuelVerifyManage/success');
  }
}, {
  path: 'fuelAdd',
  name: 'fuelAdd',
  component: function component() {
    return import('@/views/fuelManage/tms/add');
  }
}, {
  path: 'fuelList',
  name: 'fuelList',
  component: function component() {
    return import('@/views/fuelManage/tms/index');
  }
}, {
  path: 'fuelDetailTms',
  name: 'fuelDetailTms',
  component: function component() {
    return import('@/views/fuelManage/tms/detail');
  }
}, {
  path: 'fuelStatistic',
  name: 'fuelStatistic',
  component: function component() {
    return import('@/views/fuelManage/fuelStockManage/statistic');
  }
}, {
  path: 'fuelAlarmStatistics',
  name: 'fuelAlarmStatistics',
  component: function component() {
    return import('@/views/fuelManage/fuelAlarmStatisticsManage/index');
  }
}, {
  path: 'fuelAlarmRecord',
  name: 'fuelAlarmRecord',
  component: function component() {
    return import('@/views/fuelManage/fuelAlarmRecordManage/index');
  }
}];
export var activeMenu = {
  '/main/fuelSignOffManageAdd': '/main/fuelSignOffManageList',
  '/main/fuelSignOffManageDetail': '/main/fuelSignOffManageList',
  '/main/fuelSignOffManageUpdate': '/main/fuelSignOffManageList'
};